// Definir un json con los términos y condiciones de la empresa.
//

const TerminosYCondiciones = {
    "00_titulo": "Términos y Condiciones VidaPlus",
    "01_introduccion": {
        "titulo": "INTRODUCCION",
        "descripcion":"Bienvenido a la página web www.VidaPlus.com.ar y/o la aplicación móvil (en adelante la 'Plataforma' o 'VidaPlus'). Lea detenidamente los presentes Términos y Condiciones y si usted no está de acuerdo con las mismas le solicitamos que no utilice la Plataforma. Al utilizar la Plataforma, usted estará aceptando los presentes términos y condiciones (en adelante los 'Términos y Condiciones') que regulan el servicio de comunicación y de descuentos y/o beneficios que ofrece VIDAPLUS a través de la Plataforma. La Plataforma se encuentra vigente únicamente en la República Argentina.",
    },
    "02_descripcion_servicio": {
        "titulo": "DESCRICIÓN DEL SERVICIO",
        "descripcion": "VIDAPLUS es una empresa de tecnología, que ofrece a través de la Plataforma, un programa de beneficios de salud brindado por diversos prestadores. VidaPlus no es una obra social, ni una empresa de medicina prepaga, ni una compañía de seguros. No presta servicios médicos, ni de asistencia, ni de salud, ni de emergencias o urgencias.",
    },
    "03_importante": {
        "titulo": "IMPORTANTE",
        "descripcion": "En caso de que usted desee contratar una cobertura que alcance la totalidad de las prestaciones del programa médico obligatorio y las del sistema de prestaciones básicas para personas con discapacidad prevista en la ley 23.660 y sus modificatorias, no debe contratar un plan de cobertura parcial sino un plan de cobertura integral.",
    },
    "04_alcance_limitaciones": {
        "titulo": "ALCANCE Y LIMITACIONES DEL SERVICIO",
        "descripcion": "VidaPlus no garantiza la disponibilidad continua de los prestadores ni la calidad de los servicios brindados por ellos. Asimismo, se reserva el derecho de modificar o interrumpir parcial o totalmente la disponibilidad de beneficios y prestadores, notificando a los usuarios por los medios oficiales cuando corresponda.",
    },
    "05_usuarios": {
        "titulo": "USUARIOS",
        "descripcion": "Los Usuarios de la Plataforma deberán ser personas humanas mayores de edad, residentes en la República Argentina, con capacidad para contratar y trabajar en la República Argentina. No podrán registrarse y/o mantenerse activos en la plataforma de VidaPlus, las personas humanas que no tengan esa capacidad.",
    },
    "06_derechos_obligaciones": {
        "titulo": "DERECHOS Y OBLIGACIONES DEL USUARIO",
        "descripcion": "El usuario se compromete a proporcionar información veraz y actualizada en todo momento. Su cuenta de usuario es personal e intransferible y debe respetar los términos de uso de la plataforma, absteniéndose de realizar actividades fraudulentas o abusivas.",
    },
    "07_modificaciones": {
        "titulo": "MODIFICACIÓN DE LOS TERMINOS Y CONDICIONES",
        "descripcion":"VidaPlus podrá modificar los Términos y Condiciones en cualquier momento, notificando los cambios a los usuarios a través de los canales de comunicación oficiales. El uso continuado de la Plataforma luego de la notificación implicará la aceptación de las modificaciones.",
    },
    "08_reembolsos_reclamaciones": {
        "titulo": "POLITICA DE REEMBOLSOS Y RECLAMACIONES",
        "descripcion": "No se realizarán reembolsos por servicios ya abonados. Sin embargo, los usuarios podrán presentar reclamos a través de los canales de atención al cliente de VidaPlus, donde serán evaluados y gestionados según corresponda.",
   },
    "09_proteccion_datos": {
        "titulo": "PROTECCIÓN DE DATOS PERSONALES",
        "descripcion": "VidaPlus recolectará y tratará los datos personales de los usuarios de acuerdo con la Ley 25.326 de Protección de Datos Personales. La información recopilada será utilizada exclusivamente para la prestación de los servicios y no será compartida con terceros sin el consentimiento del usuario, salvo en los casos legalmente permitidos.",
    },
    "10_limitacion_responsabilidad": {
        "titulo": "LIMITACIÓN DE RESPONSABILIDAD",
        "descripcion": "VidaPlus no se hace responsable por la calidad de los servicios prestados por terceros.\nVidaPlus no asume responsabilidad por interrupciones en la Plataforma debidas a fallas técnicas o causas de fuerza mayor."
    },
    "11_planes_beneficios": {
     "titulo": "PLANES DE BENEFICIOS",
      "descripcion": "A través de la Plataforma, VidaPlus brinda a los Usuarios la posibilidad de contratar alguno de los siguientes beneficios:",
      "servicios": [
        "Consultas Médicas",
        "Red de Centros Médicos Ambulatorios",
        "Laboratorio",
        "Diagnóstico por Imágenes",
        "Fisiatría y Kinesiología",
        "Odontología",
        "Fonoaudiología",
        "Psicología",
        "Óptica",
        "Enfermería y Kinesiología a Domicilio",
        "Vacunatorio",
        "Club de Beneficio",
        "Sepelio",
        "Médico a Domicilio",
        "Descuento en Medicamentos Red Nacional",
        "Asistencia al Viajero Nacional e Internacional",
        "Seguro de Vida",
        "Telemedicina",
        "Seguros de Salud"
      ]
    },
    "12_planes_disponibles": {
      "titulo": "PLANES DISPONIBLES",
      "descripcion": "Los planes vigentes en la actualidad para contratar son los siguientes:",
      "planes": [
        "VidaPlus 100",
        "VidaPlus 200",
        "VidaPlus 300",
        "VidaPlus 400"
      ]
    },
    "13_condiciones_pago": {
        "titulo": "CONDICIONES DE PAGO Y FACTURACIÓN",
        "descripcion": "VidaPlus cobrará los abonos mensuales correspondientes a cada Plan de Beneficios, mediante tarjeta de crédito o débito a través de la Plataforma de Mercado Pago, Plus Pagos, débito automático en tarjeta de crédito, débito en cuenta bancaria, o cualquier otro medio de pago que VidaPlus habilite en el futuro."
    },
    "14_baja_servicio": {
        "titulo": "BAJA DEL SERVICIO",
        "descripcion":"El Usuario podrá solicitar la baja de su Plan de Beneficios en cualquier momento. Para ello, deberá realizar la solicitud con una anticipación mínima de 10 (diez) días hábiles previos al vencimiento del próximo período de facturación. La solicitud de baja debe realizarse a través de los canales oficiales de atención al cliente de VidaPlus, detallando nombre completo, DNI y plan contratado..."
    },
    "15_resolucion_conflictos": {
        "titulo": "RESOLUCIÓN DE CONFLICTOS Y JURISDICCIÓN",
        "descripcion": "Cualquier controversia derivada del presente contrato se regirá por las leyes de la República Argentina. Serán competentes los tribunales ordinarios de la Ciudad Autónoma de Buenos Aires."
    }
  };

export default TerminosYCondiciones;
  